<template>
    <be-card divider flat body-contrast :title="title" :subtitle="subtitle">
        <div class="row">
            <div class="d-flex flex-wrap flex-xl-nowrap col-12">
                <div class="col-xl">
                    <slot name="input"/>
                </div>

                <div class="col-xl offset-xl-1">
                    <slot name="description"/>
                    <text-area :name="name + '_notes'" label="Bemerkungen" :value="notes" :disabled="disabled" @input="output => { $emit('update:notes', output) }"/>
                </div>
            </div>
        </div>
    </be-card>
</template>

<script>
    export default {
        props: {
            name: {
                type: String,
                required: true,
            },
            title: {
                type: String,
                required: true,
            },
            subtitle: String,
            notes: String,
            disabled: Boolean,
        },
    };
</script>
